import error from './errors';
import fields from './fields';

export default {
  error,
  fields,
  app: {
    title: 'Apostilla'
  },
  btn: {
    next: 'Next',
    prev: 'Previous',
    cancel: 'Cancel',
    back: 'Go back',
    search: 'Search',
    solicitar: 'Apply for apostille',
    finalizar: 'Finalize',
    verificar: 'Check',
    register: 'Registering...',
    solicitando: 'Applying for...'
  },
  months: {
    enero: 'January',
    febrero: 'February',
    marzo: 'March',
    abril: 'April',
    mayo: 'May',
    junio: 'June',
    julio: 'July',
    agosto: 'August',
    septiembre: 'September',
    octubre: 'October',
    noviembre: 'November',
    diciembre: 'December'
  },
  menu: {
    inicio: 'Home',
    paises: 'Countries',
    tramite: 'Paperwork',
    solicitud: 'Apply for',
    seguimiento: 'Tracking',
    verificar: 'Check',
    pagos: 'Payment',
    contacto: 'Contact'
  },
  steps: {
    info_sol: 'INFORMACIÓN DEL SOLICITANTE',
    info_doc: 'DOCUMENTO(S)',
    info_pago: 'DATOS DE PAGO',
    info_finalizado: 'FINALIZADO'
  },
  inicio: {
    title: 'The apostille of HAYA in Bolivia',
    detalle: 'The Apostille of the Hague Convention is already in Bolivia and can be requested electronically through this system or assisting in person the entities that provide this service of legalization of documents from abroad.',
    btnSolicitar: 'Order apostille',
    btnSeguimiento: 'State of my order',
    btnVerificar: 'Verify my apostille'
  },
  tramite: {
    title: 'List of apostille process'
  },
  solicitud: {
    title: 'Apostille application form',
    datos_titular: ``,
    comunicado: '',
    comunicado1: '',
    comunicado2: '',
    comunicado3: ''
  },
  seguimiento: {
    title: 'Follow up of your process'
  },
  verificar: {
    title: 'Verify apostille document'
  },
  BUSCAR_TRAMITE: 'Search process',
  PRECIO: 'Price',
  VER_DETALLES: 'More details',
  SOLICITAR_APOSTILLA: 'Apply for apostille',
  ESCRIBIR_TRAMITE: 'Escriba aquí el trámite que desea buscar (en)'
};



// WEBPACK FOOTER //
// ./src/lang/en/messages.js